import { ReactNode } from 'react';
import { AuthProvider } from '../stores/authStore';
import { LanguageProvider } from '../i18n/LanguageContext';

/**
 * App-level context providers.
 *
 * AuthProvider → LanguageProvider → other providers
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <LanguageProvider>{children}</LanguageProvider>
    </AuthProvider>
  );
}

